import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { FilmsInDateRange, SortOption } from "../../types/dataTypes.ts";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material";
import { FilmTab } from "../Tabs/FilmTab.tsx";
import { sortScreenings } from "../../helpers/componentHelpers.ts";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ width: "100%" }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: { xs: 1.5, md: 3 },
          }}
        >
          <>{children}</>
        </Box>
      )}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const FilmListings = ({
  sortOption,
  filmsByDateRange,
  optimise,
  setOptimisation,
}: {
  sortOption: SortOption;
  filmsByDateRange: FilmsInDateRange[];
  optimise: boolean;
  setOptimisation: (optimise: boolean) => void;
}) => {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setOptimisation(true);
  };

  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        allowScrollButtonsMobile={true}
        aria-label="scrollable force tabs example"
        sx={{ width: "100%" }}
        scrollButtons="auto"
        TabScrollButtonProps={{
          sx: {
            color: theme.palette.primary.main,
            visibility: "visible",
            "&.Mui-disabled": {
              opacity: 0.2,
            },
          },
        }}
      >
        {filmsByDateRange.map(({ tab_date_label, film_data }, index) =>
          film_data.length > 0 ? (
            <Tab
              label={tab_date_label}
              {...a11yProps(index)}
              key={`${tab_date_label}_tab_header`}
              sx={{ fontSize: "large" }}
            />
          ) : (
            <Tab
              label={tab_date_label}
              {...a11yProps(index)}
              disabled
              key={`${tab_date_label}_tab_header`}
              sx={{ fontSize: "large" }}
            />
          )
        )}
      </Tabs>

      <>
        {filmsByDateRange.map(({ film_data, tab_date_label }, index) =>
          value === index ? (
            <CustomTabPanel
              value={value}
              index={index}
              key={`${tab_date_label}_tab_panel`}
            >
              <FilmTab
                filmData={sortScreenings(film_data, sortOption)}
                tabDateLabel={tab_date_label}
                sortOption={sortOption}
                key={`${tab_date_label}_film_tab`}
                optimise={index === 0 ? optimise : true}
              />
            </CustomTabPanel>
          ) : null
        )}
      </>
    </Box>
  );
};
